interface MaintenanceTasksTableHeader {
  label: string;
  sortableName?: string;
  infoText?: string;
  cols: {
    xs: '' | number; // mobile < 768
    md: number; // medium >= 768px
    xl: number; // desktop >= 1200
  };
  className?: string;
}

export const MAINTENANCE_INSTANCES_TABLE_HEADERS: MaintenanceTasksTableHeader[] = [
  {
    label: 'Equipment',
    sortableName: 'EquipmentName',
    cols: {
      xs: '', // mobile < 768
      md: 2, // medium >= 768px
      xl: 2 // desktop >= 1200
    },
    className: 'd-none d-md-flex'
  },
  {
    label: 'Serial or VIN Number',
    sortableName: undefined,
    cols: {
      xs: '', // mobile < 768
      md: 2, // medium >= 768px
      xl: 2 // desktop >= 1200
    },
    className: 'd-none d-md-flex'
  },
  {
    label: 'Task Name',
    sortableName: 'TaskName',
    cols: {
      xs: 4, // mobile < 768
      md: 2, // medium >= 768px
      xl: 2 // desktop >= 1200
    },
    className: 'd-flex'
  },
  {
    label: 'Due',
    sortableName: 'Due',
    infoText: `Maintenance due is normalized for sorting using internal assumptions: 1 day = 8 hours = 50 miles. This helps compare tasks across different units (days, hours, miles).`,
    cols: {
      xs: 2, // mobile < 768
      md: 1, // medium >= 768px
      xl: 1 // desktop >= 1200
    },
    className: 'd-flex'
  },
  {
    label: 'Assigned To',
    sortableName: undefined,
    cols: {
      xs: '', // mobile < 768
      md: 2, // medium >= 768px
      xl: 2 // desktop >= 1200
    },
    className: 'd-none d-md-flex'
  },
  {
    // The status pill does not shrink, so it needs 2 columns to stay inside its cell.
    label: 'Status',
    sortableName: undefined,
    cols: {
      xs: 5, // mobile < 768
      md: 2, // medium >= 768px
      xl: 2 // desktop >= 1200
    },
    className: 'd-flex'
  },
  {
    label: '',
    sortableName: undefined,
    cols: {
      xs: 1, // mobile < 768
      md: 1, // medium >= 768px
      xl: 1 // desktop >= 1200
    },
    className: 'text-end d-flex'
  }
];

export const DAILY = 1 as const;
export const WEEKLY = 2 as const;
export const MONTHLY = 3 as const;
export const YEARLY = 4 as const;
export const DAYS = 5 as const;
export const HOURS = 6 as const;
export const MILES = 7 as const;

export const MAINTENANCE_STATUSES = {
  Pending: 0,
  Overdue: 1,
  Upcoming: 2,
  Completed: 3,
  Skipped: 4,
  Scheduled: 5
} as const;

export const PROCESS_TASK_TYPES = {
  Completed: 'completed',
  Skipped: 'skipped',
  Restored: 'restored',
  Updated: 'updated'
} as const;

export const OVERDUE_STATUS = '1' as const;
export const UPCOMING_STATUS = '2' as const;
export const COMPLETED_STATUS = '3' as const;
export const SKIPPED_STATUS = '4' as const;

export const ACTIVE_EQUIPMENT_STATUS = 1 as const;
export const INACTIVE_EQUIPMENT_STATUS = 0 as const;

export const ACTIVE_EQUIPMENT_OPTION = {
  label: 'Active Equipment',
  value: ACTIVE_EQUIPMENT_STATUS
};
export const INACTIVE_EQUIPMENT_OPTION = {
  label: 'Inactive Equipment',
  value: INACTIVE_EQUIPMENT_STATUS
};

export const EQUIPMENT_STATUS_OPTIONS = [ACTIVE_EQUIPMENT_OPTION, INACTIVE_EQUIPMENT_OPTION];

export const DEFAULT_EQUIPMENT_STATUS = [ACTIVE_EQUIPMENT_OPTION];

export const OVERDUE_OPTION = { label: 'Overdue', value: OVERDUE_STATUS };
export const UPCOMING_OPTION = { label: 'Upcoming', value: UPCOMING_STATUS };
export const COMPLETED_OPTION = { label: 'Completed', value: COMPLETED_STATUS };
export const SKIPPED_OPTION = { label: 'Skipped', value: SKIPPED_STATUS };

export const MAINTENANCE_STATUS_OPTIONS = [
  OVERDUE_OPTION,
  UPCOMING_OPTION,
  COMPLETED_OPTION,
  SKIPPED_OPTION
];

export const DEFAULT_MAINTENANCE_STATUS = [OVERDUE_OPTION, UPCOMING_OPTION];

// The closed statuses - the only ones the closed-on date range applies to.
export const CLOSED_MAINTENANCE_STATUSES: string[] = [COMPLETED_STATUS, SKIPPED_STATUS];

// Sent when the status field is cleared, and the whitelist retained filters are validated against.
// Pending (0) is excluded because backend does not return it and the list cannot render it, so
// omitting Status entirely would not be safe.
export const ALL_MAINTENANCE_STATUS_VALUES: string[] = [
  OVERDUE_STATUS,
  UPCOMING_STATUS,
  COMPLETED_STATUS,
  SKIPPED_STATUS
];

export const EQUIPMENT_STATUS_VALUES: number[] = [
  ACTIVE_EQUIPMENT_STATUS,
  INACTIVE_EQUIPMENT_STATUS
];

export const THIS_INSTANCE = 0 as const;
export const THIS_AND_FUTURE = 1 as const;

export const DUE_NOW = 'due_now' as const;
export const DUE_AT = 'due_at' as const;

export const FIRST_INSTANCE_DUE_OPTIONS = [
  { label: 'Due Now', value: DUE_NOW },
  { label: 'Due At', value: DUE_AT }
] as const;

export const PROBLEMATIC_MONTHLY_DAYS = ['29', '30', '31'] as const;
export const PROBLEMATIC_YEARLY_DAY = '02/29' as const;
